/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { images } from "../../config/images";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDeviceType } from "../../sub-modules/CheckDeviceType/CheckDeviceType";

const Payments = () => {

  const navigate = useNavigate()
  //const deviceType = useDeviceType();
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const modulePrefix = searchParams.get("modulePrefix");
  const moduleDataId = searchParams.get("moduleDataId");
  const deviceType = searchParams.get("deviceType");
  const appName = searchParams.get("appName");

  const handleFallback = () => {

    if (deviceType == "web") {

      let navigationPath = "";
      if (modulePrefix == "CB") navigationPath = "/customer-court-booking-details";
      if (modulePrefix == "SB") navigationPath = "/coaching-session-booking-detail/" + moduleDataId;

      navigate(navigationPath, { state: moduleDataId })

    } else {

      let inputData = {
        moduleDataId: moduleDataId,
        modulePrefix: modulePrefix
      };

      window.postMessage(JSON.stringify(inputData));

      window.location.href = "app.powerplay.user://";
    }
  };

  return (
    <>
      <Container fluid className="g-0">
        <Row className="justify-content-md-center align-items-center">
          <Col lg={4}>
            <Card className="mt-5">
              <Card.Body className="thankyou-card">
                <img
                  src={
                    status === "paid"
                      ? images.paymentsuccess.default
                      : images.paymentcancelled.default
                  }
                  alt=""
                />
                <div className="thankyou-heading">
                  {status === "paid" ? "Thank You!" : "Payment Failed"}
                </div>
                <div className="thankyou-desc">
                  {status === "paid"
                    ? "Payment has been Successful"
                    : "Oops Payment has been Failed"}
                </div>
                <div className="d-flex justify-content-around thankyou-button">
                  {deviceType == "web" ? (
                    <a
                      onClick={handleFallback}
                      className="btn btn-primary rounded-1"
                    >
                      Go Back to Web
                    </a>
                  ) : (
                    <a
                      onClick={handleFallback}
                      className="btn btn-primary rounded-1"
                    >
                      Go Back to App
                    </a>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export { Payments };
